
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import CreateRFQSuppliers from "../../../../Components/Modal/supplier_app/Sourcing/CreateRFQSuppliers";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { checkTimeDifference } from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import { MultiselectField } from "../../../../Components/formElements/MultiselectField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import BuyerAuctionFormModal from "../BuyerAuctionFormModal";
import AuctionLineItemTable from "../AuctionLineItemTable";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import useAuctionSocket from "../../../../hooks/useAuctionSocket";
import LiveBidFeed from "../../../../Components/Auction/LiveBidFeed";
import BidSubmitPanel from "../../../../Components/Auction/BidSubmitPanel";
import PageLevelRiverseTimer from "../../../../Components/PageLevelRiverseTimer";
import SupplierLiveAuctionDashboard from "../../../../Components/Auction/SupplierLiveAuctionDashboard";
const SupplierLiveReverseAuctionDetail = () => {
  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr);
  let auctionId = useSelector(
    (state) => state.eauctionSlice.eauction.auctionNr
  );
  let userData = useSelector((state) => state?.user?.data);
  // console.log(">>user", userData);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [editorContent, setEditorContent] = useState("");
  // eslint-disable-next-line
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  // eslint-disable-next-line
  const [getINCOTerms, setINCOTerms] = useState([]);
  // eslint-disable-next-line
  const [getcurrency, setcurrency] = useState([]);
  // eslint-disable-next-line
  const [getLineItemData, setLineItemData] = useState([]);
  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  const [getFormModalData, setFormModalData] = useState({});
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [formInputs, setFormInputs] = useState({});
  // console.log(">>formInputs", formInputs);
  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour: "",
    status: false,
    msg: "",
  });
  const modalData = {
    title: "RFQ Creation",
    successMsg: "",
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  // eslint-disable-next-line
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);
  const [selectedINCOTerms, setSelectedINCOTerms] = useState([]);
const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    if (getDropdownData?.textField === "paymentTerm") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "INCOTerms") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        INCOTerms: getDropdownData?.name,
        INCOTermsCode: getDropdownData?.code,
        INCOTermsDesc: getDropdownData?.description,
        incoTerms: getDropdownData?.selected,
      }));
    } else if (getDropdownData?.textField === "auctionCurrencies") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        auctionCurrencies: getDropdownData?.name,
        auctionCurrenciesCode: getDropdownData?.code,
        auctionCurrenciesDesc: getDropdownData?.description,
        auctionCurrencie: getDropdownData?.selected,
      }));
    } else if (getDropdownData?.textField === "othercurrencies") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        othercurrencies: getDropdownData?.name,
        othercurrenciesCode: getDropdownData?.code,
        othercurrenciesDesc: getDropdownData?.description,
        othercurrencie: getDropdownData?.selected,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return d.toISOString().split("T")[0];
  };

  const loadInitialPageData = async () => {
    if (auctionId) {
      let obj = {
        documentNumber: auctionId,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      try {
        const item = await ItemService.getAuctionDetail(obj);
        if (item?.status === 200) {
          const response = item.data[0];
          setFormInputs((prev) => {
            return {
              ...prev,
              ...response,
            };
          });
          setOpenCloseInput({
            openingTime: response.openingTime || "",
            closingTime: response.closingTime || "",
            openingDate: formatDateForInput(response.openingDate),
            closingDate: formatDateForInput(response.closingDate),
          });
          if (response.instructions) setEditorContent(response.instructions);
          if (response.bidders) setBiddersData(response.bidders);
          if (response.items) setLineItemsData(response.items);
          if (response.incoTerms) setINCOTerms(response?.incoTerms);
          if (response.incoTerms) {
            setSelectedINCOTerms(response.incoTerms);
            if (response.buyerContact) {
              setbuyerContactData(response.buyerContact);
              setFormInputs((prev) => ({
                ...prev,
                buyerContact: response.buyerContact,
              }));
            }
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (err) {
        console.error("API call error:", err);
        toast.error("Something went wrong", {
          duration: 4000,
          position: "top-right",
        });
      } finally {
        toast.dismiss(toastId);
      }
    } else {
      console.warn("auctionId is missing, cannot load data.");
    }
  };

  useEffect(
    (auctionId) => {
      loadInitialPageData();
    },
    // eslint-disable-next-line
    [auctionId]
  );

  // eslint-disable-next-line
  const loadExchangeRateData = async () => {
    let obj = {
      queryName: "getExchangeRateDetails",
      documentNumber: "RFX0059",
    };
    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        setTimeout(() => {
          setauctionLineItemData(item?.data);
        }, 1000);
        setExchangeRateData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  // eslint-disable-next-line
  const loadCommercialEvaluationData = async () => {
    if (true) {
      let obj = {
        queryName: "getRFXCommEvaluationDetail",
        rfxNr: "RFX9107",
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.generateQuery(obj).then((item) => {
        if (item?.status === 200) {
          const data = item?.data[0]?.supplierList || [];
          const sorted = [...data].sort(
            (a, b) => a.qtnSubTotalLineItem - b.qtnSubTotalLineItem
          );
          const valueToRank = new Map();
          let rank = 1;
          for (let i = 0; i < sorted.length; i++) {
            const value = sorted[i].qtnSubTotalLineItem;
            if (!valueToRank.has(value)) {
              valueToRank.set(value, rank);
              rank++;
            }
          }
          setTimeout(() => {
            setauctionLineItemData(item?.data);
          }, 500);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
    }
  };

  const handleItemData = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      items: data,
    }));
  };

  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  const [getSupplierModal, setSupplierModal] = useState(false);

  const supplerMoadHide = () => {
    setSupplierModal(false);
  };

  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  // eslint-disable-next-line
  const [getSupplierData, setSupplierData] = useState([]);
  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };

  const handlePassDataToParent = (data) => {
    setSupplierData((prevData) => {
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber
            )
        ),
      ];
      return updatedData;
    });
  };

  /*  Buyer Contact Columns */
  let BuyerContactCol = [
    {
      name: "Document Item Nr",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "180px",
    },
    {
      name: "Buyer Name ",
      selector: (row) => row.buyerName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="buyerName"
          placeholder=""
          value={row.buyerName || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Buyer Email ",
      selector: (row) => row.buyerEmail || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="buyerEmail"
          placeholder=""
          value={row.buyerEmail || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Mobile Number ",
      selector: (row) => row.buyerNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="buyerNumber"
          placeholder=""
          value={row.buyerNumber || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let buyerContactData = [
    {
      local_id: 1,
      buyerEmail: "",
      buyerName: "",
      buyerNumber: "",
    },
  ];

  let lineItems = [
    {
      name: "Document Item Nr",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Item No",
      selector: (row) => row.itemNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemNo"
          value={row.itemNo || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "PR Number",
      selector: (row) => row.prNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="prNumber"
          value={row.prNumber || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "PR Line",
      selector: (row) => row.prLine || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="prLine"
          value={row.prLine || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Item Code",
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          value={row.itemCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Description",
      selector: (row) => row.itemDescription || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemDescription"
          value={row.itemDescription || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Item Text",
      selector: (row) => row.itemText || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemText"
          value={row.itemText || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="quantity"
          value={row.quantity || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "150px",
    },
    {
      name: "UOM",
      selector: (row) => row.uom || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="uom"
          value={row.uom || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "120px",
    },
    {
      name: "Internal Rate",
      selector: (row) => row.internalRate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="internalRate"
          value={row.internalRate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Item Value",
      selector: (row) => row.itemValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemValue"
          value={row.itemValue || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "RFQ Value(Min)",
      selector: (row) => row.rfqValueMin || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rfqValueMin"
          value={row.rfqValueMin || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Ceiling Price",
      selector: (row) => row.ceilingPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="ceilingPrice"
          value={row.ceilingPrice || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Auction Value",
      selector: (row) => row.auctionValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="auctionValue"
          value={row.auctionValue || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Requested Delivery Date",
      selector: (row) => row.requestedDeliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="requestedDeliveryDate"
          value={row.requestedDeliveryDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service Header Code",
      selector: (row) => row.serviceHeaderCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="serviceHeaderCode"
          value={row.serviceHeaderCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service Start Date",
      selector: (row) => row.serviceStartDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="serviceStartDate"
          value={row.serviceStartDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service End Date",
      selector: (row) => row.serviceEndDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="serviceEndDate"
          value={row.serviceEndDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Technical Specification",
      selector: (row) => row.technicalSpec || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="technicalSpec"
          value={row.technicalSpec || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "INCO Terms",
      selector: (row) => row.incoTerms || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="incoTerms"
          value={row.incoTerms || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "INCO Terms Location",
      selector: (row) => row.incoTermsLoc || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="incoTermsLoc"
          value={row.incoTermsLoc || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRowLineItem(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let lineItemsData = [
    {
      local_id: 1,
      rfxNr: 1,
      itemNo: "",
      prNumber: "",
      prLine: "",
      itemCode: "",
      itemDescription: "",
      itemText: "",
      quantity: "",
      uom: "",
      internalRate: "",
      itemValue: "",
      rfqValueMin: "",
      ceilingPrice: "",
      auctionValue: "",
      requestedDeliveryDate: "",
      serviceHeaderCode: "",
      serviceStartDate: "",
      incoTerms: "",
      serviceEndDate: "",
      technicalSpec: "",
      incoTermsLoc: "",
    },
  ];

  let bidderColumData = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Supplier Code and Name",
      selector: (row) => row.supplierCodeAndName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="supplierCodeAndName"
          value={row.supplierCodeAndName || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Country",
      selector: (row) => row.country || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="country"
          value={row.country || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Email ID",
      selector: (row) => row.emailId || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="emailId"
          value={row.emailId || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Contact No",
      selector: (row) => row.contactNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="contactNo"
          value={row.contactNo || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "User ID",
      selector: (row) => row.userId || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="userId"
          value={row.userId || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRowBiddersItem(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let biddersLineItemData = [
    {
      local_id: 1,
      rfxNr: 1,
      supplierCodeAndName: "",
      country: "",
      emailId: "",
      contactNo: "",
      userId: "",
    },
  ];

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button className="btnInfo">
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },
    {
      name: "Name",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "EMail",
      selector: (row) => row.email,
      sortable: true,
      width: "250px",
    },
    {
      name: "RFX Status",
      selector: (row) => row.rfxSupplierStatus,
      cell: (row) => (
        <>
          {row.rfxSupplierStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.rfxSupplierStatus}
            </span>
          ) : row.rfxSupplierStatus === "Regret" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.rfxSupplierStatus}
            </span>
          ) : (
            row.rfxSupplierStatus || "--"
          )}
        </>
      ),
      width: "170px",
      sortable: true,
    },
    {
      name: "Supplier Status",
      cell: (row) => (
        <>
          {row.qtnSupplierStatus === "QTN Received" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.qtnSupplierStatus}
            </span>
          ) : (
            "--"
          )}
        </>
      ),
      selector: (row) => row.qtnSupplierStatus,
      sortable: true,
      width: "150px",
    },
    {
      name: "Quotation Number",
      cell: (row) => (
        <>
          {row.qtnSupplierStatus === "QTN Received" ? (
            <button className="btnInfo">{row.quotationNr}</button>
          ) : (
            "--"
          )}
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Version",
      selector: (row) => row.qtnVersion || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      cell: (row) => (
        <>
          <span style={{ marginLeft: "12px" }}>
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.vendorCategory?.length || 0}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Company Code",
      cell: (row) => (
        <>
          <span> {row.companyCode} </span>
        </>
      ),
      width: "150px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  const aAuctionCOmpanyCOde = [
    { id: 1, desc: "", name: "SV", code: "" },
  ];

  const buyerCategories = [
    { id: 1, desc: "ProcurementDepartmentdesc", name: "Procurement Department", code: "ProcurementDepartmentcode" },
    { id: 1, desc: "PurchaseManagerdesc", name: "Purchase Manager", code: "PurchaseManagercode" },
    { id: 1, desc: "ProjectManagerdesc", name: "Project Manager", code: "ProjectManagercode" },
    { id: 1, desc: "FinanceDepartmentdesc", name: "Finance Department", code: "FinanceDepartmentcode" },
  ];

  const bidTimeOptions = [
    { id: 1, desc: "Last 5 minutesdesc", name: "Last 5 minutes", code: "5code" },
    { id: 2, desc: "Last 10 minutesdesc", name: "Last 10 minutes", code: "10code" },
  ];

  const auctionExtendedOptions = [
    { id: 1, desc: "Last 1 minutesdesc", name: "Last 1 minutes", code: "1code" },
    { id: 2, desc: "Last 2 minutesdesc", name: "Last 2 minutes", code: "10code" },
    { id: 3, desc: "Last 5 minutesdesc", name: "Last 5 minutes", code: "5code" },
  ];

  const newBidReceivedOptions = [
    { id: 1, desc: "within5minutesdesc", name: "Within last 5 minutes of auction", code: "5minutescode" },
    { id: 2, desc: "final desc", name: "During final bidding round", code: "finalcode" },
    { id: 3, desc: "live Auction desc", name: "During live auction only", code: "liveAuctioncode" },
  ];

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // eslint-disable-next-line
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  const [getbuyerContactData, setbuyerContactData] = useState(buyerContactData);
  const handleInputChange = (local_id, event) => {
    const { name, value } = event.target;
    setbuyerContactData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  const addPOItemRow = () => {
    setbuyerContactData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;
      const newRow = {
        ...buyerContactData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };
      return [...prevRows, newRow];
    });
  };

  const removePOItemRow = (local_id) => {
    setbuyerContactData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  const [getLineItemstData, setLineItemsData] = useState(lineItemsData);
  const handleLineItemsInputChange = (local_id, event) => {
    const { name, value } = event.target;
    setLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  const addPOItemRowLineItem = () => {
    setLineItemsData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;
      const newRow = {
        ...lineItemsData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };
      return [...prevRows, newRow];
    });
  };
  const removePOItemRowLineItem = (local_id) => {
    setLineItemsData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };
  const [getBiddersData, setBiddersData] = useState(biddersLineItemData);
  const handleBiddersInputChange = (local_id, event) => {
    const { name, value } = event.target;
    setBiddersData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };

  const addPOItemRowBiddersItem = () => {
    setBiddersData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;
      const newRow = {
        ...biddersLineItemData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };
      return [...prevRows, newRow];
    });
  };

  const removePOItemRowBiddersItem = (local_id) => {
    setBiddersData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  const getMasterDataFunc = async () => {
    let obj1 = { codeType: "paymentTerm" };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
      }
    });
    let obj7 = { codeType: "currency" };
    await ItemService.getMasterData(obj7).then((item) => {
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
      }
    });
    let obj8 = { codeType: "INCOTerms" };
    await ItemService.getMasterData(obj8).then((item) => {
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
      }
    });
  };

  useEffect(() => {
    getMasterDataFunc();
    localStorage.setItem("menu", "eAuction");
    localStorage.setItem("submenu", "Reverse Auction");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line
  const createDynamicformModelCOMM = () => {
    let obj = { formType: "COMM" };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };

  const hideModalStatus = () => {
    setCreateDynamicformModelShow(false);
  };

  // eslint-disable-next-line
  const [exchangeRateData, setExchangeRateData] = useState([]);

  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((getOpenCloseInput) => ({
      ...getOpenCloseInput,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);
      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";
      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        }
      }
    }
  }, [getOpenCloseInput]);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [sections, setSections] = useState([
    {
      id: 1,
      title: "Introduction",
      data: [
        { key: "1.1", text: "Dear Partners, We are very pleased to invite you to participate in above mentioned Emirates Steel Auction as mentioned in Auction Basic Information." },
        { key: "1.2", text: "Remark: This is an online bidding, hence doesn't require submission of signed, stamped hard copy proposals. * If you have any questions, please use the messages section in the auction to communicate with the buyer. No other communication channels are available." },
        { key: "1.3", text: "Deadline for the auction submission: As shown in the time ticker section on the top of the auction section." },
      ],
    },
    {
      id: 2,
      title: "Information",
      data: [
        { key: "2.1", text: "Price: Use this term to input the item / material unit Price" },
        { key: "2.2", text: "Delivery Time: Use this term to mention the delivery / lead time (in days) for the item / material" },
        { key: "2.4", text: "Supplier Payment Terms: Use this term to mention your payment terms (e.g., 30 days, 45 days, etc.)" },
        { key: "2.5", text: "Origin of Material: Use this term to mention the country of origin for the item / material" },
      ],
    },
  ]);

  // eslint-disable-next-line
  const handleAddPoint = (sectionIndex) => {
    setSections((prev) => {
      const newSections = [...prev];
      const section = newSections[sectionIndex];
      const nextPointNum = (section.data.length + 1).toFixed(1);
      const nextKey = `${section.id}.${nextPointNum}`;
      section.data.push({
        key: nextKey,
        text: "",
        isInput: true,
        inputName: `${section.title.toLowerCase()}_${nextKey.replace(".", "_")}`,
      });
      return newSections;
    });
  };

  const [getDisabled, setDIsabledField] = useState(false);

  useEffect(() => {
    setDIsabledField(true);
  }, []);

  // eslint-disable-next-line
  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [itemLeaderboard, setItemLeaderboard] = useState([]);

  // ── Socket: Real-time Bidding (Supplier view) ──────────────────────────────
  const _localData = (() => {
    try { return JSON.parse(localStorage.getItem("userData") || "{}"); }
    catch { return {}; }
  })();
  const loggedSupplierCode = _localData?.data?.userId || _localData?.userId || "";
  const loggedSupplierName = _localData?.data?.firstName || _localData?.data?.organisationName || _localData?.userName || "";

  const {
    isConnected: socketConnected,
    liveBids,
    liveBidRanking,
    lastBidStatus,
    auctionStatus: socketAuctionStatus,
    emitPlaceBid,
    emitRequestLeaderboard,
    serverRemainingSeconds,
    auctionExtendedData,
    itemLeaderboard: socketItemLeaderboard,
    itemMbd: socketItemMbd,
    itemReservePrice: socketItemReservePrice,
    firstQuote: socketFirstQuote,
    firstQuoteBy: socketFirstQuoteBy,
    //eslint-disable-next-line
    auctionType: socketAuctionType,
    // ── NEW: bidAgainst from socket (server-authoritative) ─────────────────
    bidAgainst: socketBidAgainst,
  } = useAuctionSocket(auctionId, "supplier", loggedSupplierCode, loggedSupplierName);

  // ── Auto-refresh leaderboard every 3 seconds ───────────────────────────────
  useEffect(() => {
    if (!socketConnected) return;
    const refreshInterval = setInterval(() => {
      emitRequestLeaderboard();
    }, 3000);
    return () => clearInterval(refreshInterval);
  }, [socketConnected, emitRequestLeaderboard]);

  // ── Poll item-level leaderboard every 5 seconds ────────────────────────────
  useEffect(() => {
    if (!auctionId) return;
    const fetchItemLeaderboard = async () => {
      try {
        const res = await ItemService.auctionGetItemLeaderboard({ auctionId });
        if (res?.data) setItemLeaderboard(res.data);
      } catch (e) { /* silent */ }
    };
    fetchItemLeaderboard();
    const t = setInterval(fetchItemLeaderboard, 5000);
    return () => clearInterval(t);
  }, [auctionId]);

  // ── Sync timer when auction extended via socket ────────────────────────────
  useEffect(() => {
    if (serverRemainingSeconds != null && serverRemainingSeconds > 0) {
      const secs = serverRemainingSeconds;
      setFinalTimerValue({
        days:    Math.floor(secs / 86400),
        hours:   Math.floor((secs % 86400) / 3600),
        minutes: Math.floor((secs % 3600) / 60),
        seconds: secs % 60,
      });
    }
  }, [serverRemainingSeconds]);

  // ── Auto-extension: cascade serial/staggered lot timings ──────────────────
  useEffect(() => {
    if (!auctionExtendedData) return;
    const { extendedByMs, newEndTime } = auctionExtendedData;
    if (!extendedByMs && !newEndTime) return;

    setFormInputs(prev => {
      const now = new Date();
      const updatedTimings = { ...(prev.bidTimings || {}) };
      const bidConfig = prev.bidConfigType || "parallel";

      if (bidConfig === "serial") {
        let activeLotKey = null;
        let activeLotNewEnd = null;

        Object.entries(updatedTimings).forEach(([key, timing]) => {
          if (!timing) return;
          const start = new Date(timing.startTime);
          const end   = new Date(timing.endTime);
          if (now >= start && now < end) {
            activeLotKey    = String(timing.lotNumber);
            activeLotNewEnd = extendedByMs
              ? new Date(end.getTime() + extendedByMs)
              : new Date(newEndTime);
          }
        });

        if (!activeLotKey) return prev;

        const lotMap = {};
        Object.entries(updatedTimings).forEach(([key, timing]) => {
          const lotNo = String(timing?.lotNumber ?? "");
          if (!lotMap[lotNo]) lotMap[lotNo] = [];
          lotMap[lotNo].push(key);
        });

        const sortedLots = Object.keys(lotMap).filter(l => l !== "").sort((a, b) => Number(a) - Number(b));
        const activeLotIndex = sortedLots.indexOf(activeLotKey);

        lotMap[activeLotKey]?.forEach(key => {
          updatedTimings[key] = { ...updatedTimings[key], endTime: activeLotNewEnd };
        });

        for (let i = activeLotIndex + 1; i < sortedLots.length; i++) {
          const prevLotEnd = new Date(updatedTimings[lotMap[sortedLots[i - 1]][0]]?.endTime);
          const currKeys   = lotMap[sortedLots[i]];
          const currTiming = updatedTimings[currKeys[0]];
          const lotDuration = new Date(currTiming.endTime) - new Date(currTiming.startTime);
          currKeys.forEach(key => {
            updatedTimings[key] = {
              ...updatedTimings[key],
              startTime: prevLotEnd,
              endTime:   new Date(prevLotEnd.getTime() + lotDuration),
            };
          });
        }

      } else if (bidConfig === "staggered") {
        const itemsSorted = Object.entries(updatedTimings)
          .sort((a, b) => (a[1].serialNumber || 0) - (b[1].serialNumber || 0));

        let extendedIdx = -1;
        itemsSorted.forEach(([key, timing], idx) => {
          if (extendedIdx !== -1) return;
          const end = new Date(timing.endTime);
          if (now < end) {
            extendedIdx = idx;
            updatedTimings[key] = {
              ...timing,
              endTime: extendedByMs
                ? new Date(end.getTime() + extendedByMs)
                : new Date(newEndTime),
            };
          }
        });

        for (let i = extendedIdx + 1; i < itemsSorted.length; i++) {
          const [prevKey]             = itemsSorted[i - 1];
          const [currKey, currTiming] = itemsSorted[i];
          const prevOrigEnd           = new Date(itemsSorted[i - 1][1].endTime);
          const currOrigEnd           = new Date(currTiming.endTime);
          const interval              = currOrigEnd - prevOrigEnd;
          const newPrevEnd            = new Date(updatedTimings[prevKey].endTime);
          updatedTimings[currKey] = { ...currTiming, endTime: new Date(newPrevEnd.getTime() + interval) };
        }
      }

      return { ...prev, bidTimings: updatedTimings };
    });
  }, [auctionExtendedData]); // eslint-disable-line

  const [auctionlineItemData, setauctionLineItemData] = useState([]);

  const [hideItem, setHideItem] = useState(false);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;
    // console.log("userRole", userRole);
    if (userRole === "VENDOR") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  // eslint-disable-next-line
  let lineItemsforData = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "120px",
      center: true,
    },
    {
      name: "Item Code",
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          value={row.itemCode || ""}
          disabled
        />
      ),
      width: "220px",
    },
    {
      name: "Name",
      selector: (row) => row.itemNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemNo"
          value={row.itemNo || ""}
          disabled
        />
      ),
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.itemDescription || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemDescription"
          value={row.itemDescription || ""}
          disabled
        />
      ),
      width: "200px",
    },
    {
      name: "UOM",
      selector: (row) => row.uom || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="uom"
          value={row.uom || ""}
          disabled
        />
      ),
      width: "200px",
    },
    ...(formInputs.startPrice
      ? [
          {
            name: "Start Price",
            selector: (row) => formInputs.itemPrices?.[row.local_id] || "--",
            cell: (row) => (
              <InputField
                className="inputBox mt-1"
                name="startPrice"
                value={formInputs.itemPrices?.[row.local_id] || ""}
                disabled
              />
            ),
            width: "200px",
          },
        ]
      : []),
  ];

  const isAuctionActuallyEnded =
    socketAuctionStatus === "ended" &&
    (serverRemainingSeconds == null || serverRemainingSeconds <= 0);

  // ── Resolve effective bidAgainst:
  //    Priority: socket (server-authoritative) → formInputs (DB) → default
  const effectiveBidAgainst =
    socketBidAgainst || formInputs?.bidAgainst || "leadingPrice";

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Live Reverse Auction Details
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {auctionId}
              </span>
            </h2>
            <p className="subText">Live Reverse Auction Details</p>
            <hr />

            {/*  Auction Title + Line Items Summary  */}

            {/*  Live Board + Bid Panel (Socket)  */}
            <Row className="mb-4">
           

              {/*  Countdown Timer  */}
              <div style={{
                marginBottom: "20px",
                background: "linear-gradient(135deg, rgb(183, 216, 213), rgb(159, 199, 195));",
                borderRadius: "12px",
                padding: "16px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 4px 20px rgba(15,118,110,0.22)",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <img
                    src="assets/img/stopwatch.png"
                    alt="stopwatch"
                    style={{ width: "48px", height: "48px", filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.3))" }}
                  />
                  <div>
                    <div style={{ color: "black", fontSize: "11px", fontWeight: 650, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      {isAuctionActuallyEnded ? "⏹️ Auction Ended" : "🟢 Live"}
                    </div>
                    {getOpenCloseInput.closingDate && (
                      <div style={{ color: "black", fontSize: "12px", marginTop: "3px" }}>
                        Closes: <strong>{getOpenCloseInput.closingDate} {getOpenCloseInput.closingTime}</strong>
                      </div>
                    )}
                  </div>
                </div>
                <PageLevelRiverseTimer timerData={finalTimerValue} />
              </div>

              {/*  Supplier Live Auction Dashboard  */}
              <Col xs={12}>
              <SupplierLiveAuctionDashboard
                liveBids={liveBids}
                liveBidRanking={liveBidRanking}
                itemLeaderboard={socketItemLeaderboard?.length > 0 ? socketItemLeaderboard : itemLeaderboard}
                auctionItems={formInputs?.items || []}
                auctionStatus={socketAuctionStatus}
                closingDateTime={`${getOpenCloseInput.closingDate || ""} ${getOpenCloseInput.closingTime || ""}`}
                openingDateTime={`${getOpenCloseInput.openingDate || ""} ${getOpenCloseInput.openingTime || ""}`}
                auctionTitle={formInputs?.auctionTitle || ""}
                auctionId={auctionId}
                auctionCurrency={formInputs?.auctionCurrenciesCode || ""}
                autoExtensionMins={formInputs?.auctionAutoExtended || 2}
                displayRank={formInputs?.displayRank || "showToAll"}
                mbdType={formInputs?.mbdType || "anyAmount"}
                mbdValue={parseFloat(formInputs?.mbdValue || formInputs?.decrementValue) || 0}
                fractions={formInputs?.fractions || "2"}
                vendorMasking={formInputs?.vendorMasking === true}
                currentUserCode={loggedSupplierCode}
                supplierName={loggedSupplierName}
                serverRemainingSeconds={serverRemainingSeconds}
                emitPlaceBid={emitPlaceBid}
                lastBidStatus={lastBidStatus}
                formInputs={formInputs}
                bidType={formInputs?.bidType || "perUnit"}
                itemMbd={socketItemMbd && Object.keys(socketItemMbd).length > 0 ? socketItemMbd : (formInputs?.itemMbd || {})}
                itemQuantities={formInputs?.itemQuantities || {}}
                itemReservePrice={socketItemReservePrice && Object.keys(socketItemReservePrice).length > 0 ? socketItemReservePrice : (formInputs?.itemReservePrice || {})}
              />
              </Col>

              <Col xs={12} md={12} lg={12}>
                <BidSubmitPanel
                  auctionItems={formInputs?.items || []}
                  mbdType={formInputs?.mbdType || "anyAmount"}
                  mbdValue={parseFloat(formInputs?.mbdValue || formInputs?.decrementValue) || 0}
                  startPrice={formInputs?.startPrice || false}
                  itemPrices={formInputs?.itemPrices || {}}
                  currency={formInputs?.auctionCurrenciesCode || formInputs?.auctionCurrencies || ""}
                  fractions={formInputs?.fractions || "2"}
                  emitPlaceBid={emitPlaceBid}
                  lastBidStatus={lastBidStatus}
                  auctionStatus={socketAuctionStatus}
                  isConnected={socketConnected}
                  supplierCode={loggedSupplierCode}
                  supplierName={loggedSupplierName}
                  auctionId={auctionId}
                  liveBidRanking={liveBidRanking}
                  auctionMode={formInputs?.auctionType}
                  bidConfigType={formInputs?.bidConfigType || "parallel"}
                  bidTimings={formInputs?.bidTimings || {}}
                  bidType={formInputs?.bidType || "perUnit"}
                  itemQuantities={formInputs?.itemQuantities || {}}
                  itemLeaderboard={socketItemLeaderboard?.length > 0 ? socketItemLeaderboard : itemLeaderboard}
                  userRole="supplier"
                  serverRemainingSeconds={serverRemainingSeconds}
                  itemMbd={socketItemMbd && Object.keys(socketItemMbd).length > 0 ? socketItemMbd : (formInputs?.itemMbd || {})}
                  itemReservePrice={socketItemReservePrice && Object.keys(socketItemReservePrice).length > 0 ? socketItemReservePrice : (formInputs?.itemReservePrice || {})}
                  supplierInitialPrices={formInputs?.supplierInitialPrices}
                  supplierList={getSupplierData}
                  firstQuoteBy={socketFirstQuoteBy || formInputs?.firstQuoteBy || "Supplier"}
                  firstQuote={socketFirstQuote || formInputs?.firstQuote || false}
                  // ── NEW: pass server-authoritative bidAgainst ──────────────
                  bidAgainst={effectiveBidAgainst}
                />
              </Col>

                 <Col xs={12} md={12} lg={12} className="mb-3 mb-md-0">
               
                <LiveBidFeed
  liveBids={liveBids}
  liveBidRanking={liveBidRanking}
  isConnected={socketConnected}
  auctionStatus={socketAuctionStatus}
  userRole="supplier"
  currentUserCode={loggedSupplierCode}
  displayRank={formInputs?.displayRank || "showToAll"}
  itemLeaderboard={itemLeaderboard}
  auctionId={auctionId}
  firstQuote={socketFirstQuote || formInputs?.firstQuote || false}
  firstQuoteBy={socketFirstQuoteBy || formInputs?.firstQuoteBy || "Supplier"}
  supplierInitialPrices={formInputs?.supplierInitialPrices || {}}
  supplierList={formInputs?.supplierList || []}
/>
              </Col>
            </Row>

            {!hideItem && (
              <>
                {/* 01 - Additional Information */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">AI</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Reverse Auction Additional Information</span>
                          <span className="subHeaderTitle">Reverse Auction Additional Information Form</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              label="Company Code"
                              placeholder=""
                              data={aAuctionCOmpanyCOde}
                              id="companyCodeType"
                              iconClassName="dropdownIcon"
                              name="companyCodeType"
                              code="companyCodeTypeCode"
                              description="companyCodeTypeDesc"
                              setValue={formInputs?.companyCodeType || ""}
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              label="Payment Term"
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerm"
                              iconClassName="dropdownIcon"
                              name="paymentTerm"
                              setValue={formInputs.paymentTerm || ""}
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <MultiselectField
                              label="INCO Terms"
                              placeholder="Please select the INCO Terms"
                              data={getINCOTerms}
                              id="INCOTerms"
                              iconClassName="dropdownIcon"
                              name="INCOTerms"
                              setValue={selectedINCOTerms}
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="INCO Terms Location"
                              name="incoTermsLocation"
                              id="incoTermsLocation"
                              placeholder=""
                              value={formInputs?.incoTermsLocation || ""}
                              onChange={onInputChange}
                              disabled={getDisabled}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 02 - Basic Information */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">BI</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Additional Basic Information</span>
                          <span className="subHeaderTitle">Reverse Auction Basic Information Form</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Tentative Start Time"
                              name="openingDate"
                              id="openingDate"
                              type="date"
                              placeholder=""
                              value={getOpenCloseInput.openingDate || ""}
                              onChange={onInputChangeopeningDate}
                              required={true}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Duration(HH:MM)"
                              name="openingTime"
                              id="openingTime"
                              type="time"
                              placeholder=""
                              value={getOpenCloseInput.openingTime || ""}
                              onChange={onInputChangeopeningDate}
                              required={true}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Tentitative End Date"
                              name="closingDate"
                              id="closingDate"
                              type="date"
                              placeholder=""
                              value={getOpenCloseInput.closingDate || ""}
                              onChange={onInputChangeopeningDate}
                              required={true}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Tentitative End Time(HH:MM)"
                              name="closingTime"
                              id="closingTime"
                              type="time"
                              placeholder=""
                              value={getOpenCloseInput.closingTime || ""}
                              onChange={onInputChangeopeningDate}
                              required={true}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Auction Type"
                              name="auctionType"
                              id="auctionType"
                              placeholder=""
                              value={formInputs?.auctionType || ""}
                              onChange={onInputChange}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Reference RFQ Number"
                              name="referenceRfqNumber"
                              id="referenceRfqNumber"
                              value={formInputs?.referenceRfqNumber || ""}
                              onChange={onInputChange}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Decrement In Auction Currency"
                              name="decrementValue"
                              id="decrementValue"
                              value={formInputs?.decrementValue || ""}
                              onChange={onInputChange}
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <MultiselectField
                              label="Auction Currency"
                              placeholder="Please select the Other Currencies"
                              data={getcurrency}
                              id="auctionCurrencies"
                              iconClassName="dropdownIcon"
                              name="auctionCurrencies"
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <MultiselectField
                              label="Other Currency"
                              placeholder="Please select the Other Currencies"
                              data={getcurrency}
                              id="othercurrencies"
                              iconClassName="dropdownIcon"
                              name="othercurrencies"
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              className="inputBox"
                              label="Buyer Category"
                              data={buyerCategories}
                              name="buyerCategory"
                              id="buyerCategory"
                              setValue={formInputs?.buyerCategory}
                              getvalue={setDropdownData}
                              required
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <InputField
                              className="inputBox"
                              label="Title"
                              name="auctionTitle"
                              id="auctionTitle"
                              placeholder=""
                              value={formInputs?.auctionTitle || ""}
                              onChange={onInputChange}
                              required
                              showTooltip
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <TextAreaField
                              className="inputBox"
                              label="Description"
                              name="auctionDescription"
                              id="auctionDescription"
                              value={formInputs?.auctionDescription || ""}
                              onChange={onInputChange}
                              required
                              showTooltip
                              disabled={getDisabled}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Information 06 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible6 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">AI</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">Reverse Auction Contact Information</span>
                          <span className="subHeaderTitle">Reverse Auction Contact Information Details</span>
                        </Col>
                        <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                          {!getDisabled && (
                            <Col xs={4} md={2} lg={2} className="">
                              <button className="btnTable" onClick={addPOItemRow}>+</button>
                            </Col>
                          )}
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable columns={BuyerContactCol} data={getbuyerContactData} />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rules And Settings 05 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">AI</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Reverse Actions Rules And Settings</span>
                          <span className="subHeaderTitle">Reverse Actions Rules And Settings Form</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col xs={12} md={1} lg={1} className="commTopButtonRightLeftPadding d-flex align-items-center">
                            {(formInputs?.others && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() => handleViewFile(formInputs?.others)}
                              />
                            )) || "--"}
                          </Col>
                        </Row>
                        <Row>
                          {[
                            { name: "allowBidders", label: "Allow Bidders To Select Item For Bidding" },
                            { name: "displayBidRank", label: "Display Bid Rank" },
                            { name: "ceilingPrice", label: "Celling Price" },
                            { name: "tieBidAllowed", label: "Tie Bid Allow" },
                          ].map(({ name, label }) => (
                            <Col key={name} xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex align-items-center">
                              <div>
                                <label className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2" htmlFor={name}>
                                  {label}
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name={name}
                                  id={name}
                                  checked={formInputs?.[name] || false}
                                  onChange={(e) => setFormInputs((prev) => ({ ...prev, [name]: e.target.checked }))}
                                  disabled={getDisabled}
                                />
                                <span className="ms-2">{formInputs?.[name] ? "Yes" : "No"}</span>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Auto Extension Rules 07 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible7 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility7}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">AR</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">Revrse Auction Auto Extension Rules</span>
                          <span className="subHeaderTitle">Reverse Auction Auto Extension Rules and Settings</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              label="When new bid is received for the below mentioned bid level"
                              data={bidTimeOptions}
                              id="newBidReceived"
                              iconClassName="dropdownIcon"
                              name="newBidReceived"
                              setValue={formInputs?.newBidReceived}
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              label="Auction will be auto-extended by below mentioned minutes"
                              data={auctionExtendedOptions}
                              id="auctionAutoExtended"
                              iconClassName="dropdownIcon"
                              name="auctionAutoExtended"
                              setValue={formInputs?.auctionAutoExtended}
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                            <ComboboxField
                              label="When new bid is received for the below mentioned bid level"
                              data={newBidReceivedOptions}
                              id="newBidReceivedTime"
                              iconClassName="dropdownIcon"
                              name="newBidReceivedTime"
                              setValue={formInputs?.newBidReceivedTime}
                              getvalue={setDropdownData}
                              className="dropdownOption"
                              disabled={getDisabled}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Instructions Bidders 08 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible8 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility8}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">IB</span>
                        </Col>
                        <Col xs={8} md={6} lg={6}>
                          <span className="headerTitle">Form: Instructions Bidders</span>
                        </Col>
                        <Col xs={12} md={5} lg={5} className="headerButtonAlign"></Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row></Row>
                      </div>
                      <div>
                        {sections.map((section, sectionIndex) => (
                          <Row key={section.id} className="mb-3 p-3 border rounded">
                            <Col xs={12}>
                              <h5 className="mb-3">{section.title}</h5>
                              {section.data.map((point, pointIndex) => (
                                <div key={point.key} className="p-1">
                                  <strong>{point.key}</strong>{" "}
                                  {point.isInput ? (
                                    <Row className="align-items-center mt-1">
                                      <Col xs={12} sm={6} md={4}>
                                        <InputField
                                          name={point.inputName}
                                          value={formInputs[point.inputName] || ""}
                                          onChange={onInputChange}
                                          className="inputBox"
                                        />
                                      </Col>
                                    </Row>
                                  ) : (
                                    point.text
                                  )}
                                </div>
                              ))}
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Auction Note 10 */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">AN</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Auction Note</span>
                          <span className="subHeaderTitle">Auction RUles And Notes</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row className="p-4">
                          <Col xs={12} md={12} lg={12}>
                            <RichTextEditor value={editorContent} onChange={handleEditorChange} />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Ceiling Price And Settings */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">CS</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">Ceiling Price And Settings</span>
                          <span className="subHeaderTitle">Ceiling Price And Settings Form</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} className="mb-1 mt-2 ms-3">
                            <h4 className="fw-bold">CeilingPrice <span className="text-danger">*</span></h4>
                          </Col>
                        </Row>
                        <Row>
                          {[
                            { name: "lineItemWise", label: "LineItem Wise" },
                            { name: "supplierWise", label: "Supplier Wise" },
                          ].map(({ name, label }) => (
                            <Col key={name} xs={12} md={3} lg={3} className="commTopButtonRightLeftPadding d-flex align-items-center">
                              <div>
                                <label className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2" htmlFor={name}>
                                  {label}
                                </label>
                              </div>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  role="switch"
                                  name={name}
                                  id={name}
                                  checked={formInputs?.[name] || false}
                                  onChange={(e) => setFormInputs((prev) => ({ ...prev, [name]: e.target.checked }))}
                                  disabled={getDisabled}
                                />
                                <span className="ms-2">{formInputs?.[name] ? "Yes" : "No"}</span>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Items For Bidding */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible6 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">IB</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">Items For Bidding</span>
                          <span className="subHeaderTitle">Auction Contact Information Details</span>
                        </Col>
                        <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                          {!getDisabled && (
                            <Col xs={4} md={2} lg={2} className="">
                              <button className="btnTable" onClick={addPOItemRowLineItem}>+</button>
                            </Col>
                          )}
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable columns={lineItems} data={getLineItemstData} />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bidders */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible6 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">BS</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">Bidders</span>
                          <span className="subHeaderTitle">Bidders Section</span>
                        </Col>
                        <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                          {!getDisabled && (
                            <Col xs={4} md={2} lg={2} className="">
                              <button className="btnTable" onClick={addPOItemRowBiddersItem}>+</button>
                            </Col>
                          )}
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable columns={bidderColumData} data={getBiddersData} />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Supplier List */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">SD</span>
                        </Col>
                        <Col xs={12} md={6} lg={7}>
                          <span className="headerTitle">Suppliers</span>
                          <span className="subHeaderTitle">Selected Suppliers Details</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}>
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable columns={suppliersColumns} data={formInputs?.supplierList} selectableRows />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Line Items */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                          <i
                            className={`bi ${isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"}`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                          <span className="iconLogo">LI</span>
                        </Col>
                        <Col xs={4} md={8} lg={7}>
                          <span className="headerTitle">Line Item</span>
                        </Col>
                      </Row>
                    </h2>
                    <div className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""}`}>
                      <div className="accordion-body autoScroll">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <AuctionLineItemTable
                              data={auctionlineItemData}
                              sendDataToParent={handleItemData}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      <CreateRFQSuppliers
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />
      <BuyerAuctionFormModal
        show={getCreateDynamicformModelShow}
        onHide={() => hideModalStatus()}
        modeldata={getFormModalData}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default SupplierLiveReverseAuctionDetail;
